import { queries } from "@/graphql";
import { useQuery } from "@apollo/client/react";

/**
 * Custom hook to fetch the companies associated with a user.
 * @param {string} userId - The ID of the user.
 * @returns {{companies: Array<object>, loading: boolean, error: object}} - The list of companies, loading state, and error.
 */
export function useUserCompanies(userId: string | null) {
  const { data, loading } = useQuery<any>(queries.getUserProfile, {
    variables: {
      userId,
    },
  });

  return {
    customers: data?.getUser?.teams || data?.comGetUser?.teams || [],
    userName: data?.getUser?.name || data?.comGetUser?.name || "",
    loading,
  };
}
